import { render, staticRenderFns } from "./AssignEntityReationshipDataWidget.vue?vue&type=template&id=6f2dc86f&scoped=true"
import script from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
export * from "./AssignEntityReationshipDataWidget.vue?vue&type=script&lang=js"
import style0 from "./AssignEntityReationshipDataWidget.vue?vue&type=style&index=0&id=6f2dc86f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2dc86f",
  null
  
)

export default component.exports